<template>
  <div class="Bounced">
    <transition name="el-fade-in-linear">
      <div class="mask" v-if="showModal" @click="on"></div>
    </transition>
    <transition name="el-fade-in-linear">
      <div class="pop" v-if="showModal">
        <el-row>
          <el-col
            :xs="{span: 24, offset: 0}"
            :sm="{span: 24, offset: 0}"
            :lg="{span: 24, offset: 0}"
          >
            <div class="block">
              <div class="title">
                <div class="logo">
                  <img src="./../assets/img/logo.png" alt />
                </div>
                <div @click="on" class="down">
                  <span></span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="hidden-xs-only hidden-sm-only" :lg="{span: 12, offset: 0}">
            <div class="block">
              <div class="text">
                <ul>
                  <li class="clearfix">
                    <span class="name">技术支持:</span>
                    <span class="con">
                      +86 010-68618216
                    </span>
                  </li>
                  <li class="clearfix">
                    <span class="name">咨询热线:</span>
                    <span class="con">+86 010-68618216</span>
                  </li>
                  <li class="clearfix">
                    <span class="name">电子邮件：</span>
                    <span class="con">
                      lim@mpacn.net
                    </span>
                  </li>
                  <li class="clearfix">
                    <span class="name">地 址:</span>
                    <span class="con">
                      北京市石景山区鲁谷路35号 电科大厦13层
                      <br />
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <!-- <el-col
            :xs="{span: 24, offset: 0}"
            :sm="{span: 24, offset: 0}"
            :lg="{span: 12, offset: 0}"
          >
            <div class="block">
              <div class="erweima">
                <div class="header clearfix">
                  <div class="erweimaLogo">
                    <img src="./../assets/img/logo2.png" alt />
                  </div>
                  <div class="erweimaLogoText">
                    <span>MPA联合体-官方客服</span>
                  </div>
                </div>
                <div class="img">
                  <img src="./../assets/img/erweima.png" alt />
                </div>
                <label>扫一扫上面的二维码图案，加我微信</label>
              </div>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Bounced',
  props: {
  },
  data () {
    return {
      showModal: false
    }
  },
  mounted () {
  },
  methods: {
    on: function () {
      if (this.showModal === true) {
        this.showModal = false
      } else {
        this.showModal = true
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "./../assets/color.less";

.Bounced {
  .mask {
    background-color: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
  }
  .pop {
    width: 620px;
    height: 430px;
    background: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -215px 0 0 -310px;
    text-align: center;
    padding: 0 0 24px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    z-index: 99999999;
    overflow: hidden;
    .el-row {
      .el-col {
        .block {
          .title {
            position: relative;
            margin: 0 auto;
            padding: 12px 0 12px;
            width: 100%;
            height: auto;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            border-bottom: 1px solid @font_black_95;
            background: @font_black_98;
            .logo {
              width: auto;
              height: 45px;
              img {
                width: auto;
                height: 100%;
              }
            }
            .down {
              position: absolute;
              right: 14px;
              top: 16px;
              width: 40px;
              height: 40px;
              cursor: pointer;
              span {
                display: block;
                width: 100%;
                height: 100%;
                background: url("./../assets/img/down.png") no-repeat
                  center;
                background-size: 100% auto;
              }
            }
          }
          .text {
            padding: 66px 30px;
            ul {
              li {
                margin-bottom: 12px;
                span {
                  float: left;
                  display: block;
                  font-size: 14px;
                  line-height: 20px;
                  color: @font_black_45;
                  text-align: left;
                }
                span:nth-child(1) {
                  font-weight: 600;
                  width: 70px;
                }
                span:nth-child(2) {
                  width: calc(100% - 70px);
                }
              }
            }
          }
          .erweima {
            padding: 50px 30px;
            // width: 100%;
            // height: 240px;
            // margin-top: 50px;
            // img{
            //     width: auto;
            //     height: 100%;
            // }
            .header {
              width: 100%;
              height: 45px;
              .erweimaLogo {
                float: left;
                width: auto;
                height: 100%;
                img {
                  width: auto;
                  height: 100%;
                }
              }
              .erweimaLogoText {
                float: left;
                span {
                  padding-left: 8px;
                  font-size: 15px;
                  line-height: 28px;
                  font-weight: 600;
                  color: @font_black_15;
                  text-align: left;
                }
              }
            }
            .img {
              margin: 12px auto 36px;
              width: 130px;
              height: 130px;
              background-color: @white;
              border: 1px solid @font_black_95;
              border-radius: 4px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            label {
              font-size: 12px;
              line-height: 18px;
              color: @font_black_45;
            }
          }
        }
      }
    }
  }
}
@media all and (max-width: 768px) {
  .Bounced {
    .mask {
      background-color: #000;
      opacity: 0.5;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
    }
    .pop {
      margin: 0 auto;
      width: 94%;
      height: 430px;
      background: #fff;
      position: fixed;
      top: 20%;
      left: 3%;
      text-align: center;
      padding: 0 0 24px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
      border-radius: 6px;
      z-index: 99999999;
      overflow: hidden;
      .el-row {
        .el-col {
          .block {
            .title {
              position: relative;
              margin: 0 auto;
              padding: 12px 0 12px;
              width: 100%;
              height: auto;
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
              border-bottom: 1px solid @font_black_95;
              background: @font_black_98;
              .logo {
                width: auto;
                height: 45px;
                img {
                  width: auto;
                  height: 100%;
                }
              }
              .down {
                position: absolute;
                right: 14px;
                top: 16px;
                width: 40px;
                height: 40px;
                cursor: pointer;
                span {
                  display: block;
                  width: 100%;
                  height: 100%;
                  background: url("./../assets/img/down.png") no-repeat
                    center;
                  background-size: 100% auto;
                }
              }
            }
            .text {
              padding: 66px 30px;
              ul {
                li {
                  margin-bottom: 12px;
                  span {
                    float: left;
                    display: block;
                    font-size: 14px;
                    line-height: 20px;
                    color: @font_black_45;
                    text-align: left;
                  }
                  span:nth-child(1) {
                    font-weight: 600;
                    width: 70px;
                  }
                  span:nth-child(2) {
                    width: calc(100% - 70px);
                  }
                }
              }
            }
            .erweima {
              padding: 50px 30px;
              // width: 100%;
              // height: 240px;
              // margin-top: 50px;
              // img{
              //     width: auto;
              //     height: 100%;
              // }
              .header {
                width: 100%;
                height: 45px;
                .erweimaLogo {
                  float: left;
                  width: auto;
                  height: 100%;
                  img {
                    width: auto;
                    height: 100%;
                  }
                }
                .erweimaLogoText {
                  float: left;
                  span {
                    padding-left: 8px;
                    font-size: 15px;
                    line-height: 28px;
                    font-weight: 600;
                    color: @font_black_15;
                    text-align: left;
                  }
                }
              }
              .img {
                margin: 12px auto 36px;
                width: 130px;
                height: 130px;
                background-color: @white;
                border: 1px solid @font_black_95;
                border-radius: 4px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              label {
                font-size: 12px;
                line-height: 18px;
                color: @font_black_45;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Bounced.vue